import { FC } from 'react';
import { ListHeader, ListHeaderRow } from '@csp/csp-web-ui';
import { KitContainersColSettings } from '../model/KitContainersColSettings';
import { BioSampleContainerItemMapper } from '../../mapper/BioSampleContainerItemMapper';

const { containerWidth, descriptionWidth, statusWidth, patientVisitWidth, actionsWidth } =
  KitContainersColSettings.cols;

export const KitContainersListHeader: FC = () => {
  const texts = BioSampleContainerItemMapper.toBioSampleContainerDisplayLabels();

  return (
    <ListHeaderRow alignItems="center" px={2.5}>
      <ListHeader {...containerWidth}>{texts.sampleContainerCodeLabel}</ListHeader>
      <ListHeader {...descriptionWidth}>{texts.containerDescriptionLabel}</ListHeader>
      <ListHeader {...statusWidth}>{texts.sampleStatusLabel}</ListHeader>
      <ListHeader {...patientVisitWidth}>{texts.containerPatientVisitLabel}</ListHeader>
      <ListHeader {...actionsWidth} />
    </ListHeaderRow>
  );
};
